// SMS segment counting for the campaign composer. Segments are what carriers
// bill, so this mirrors the counter in companion/src/lib/sms.ts.

/** Longest campaign SMS we accept, compliance line included. Telnyx joins the
 * parts back together on the handset; the cap is ours, to keep cost in check. */
export const CAMPAIGN_SMS_MAX_CHARS = 250;

// GSM 03.38 basic set, plus the extension table whose characters cost two.
const GSM_BASIC =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EXTENDED = '^{}\\[~]|€\f';

export interface SegmentInfo {
  encoding: 'GSM-7' | 'UCS-2';
  units: number;
  segments: number;
}

export function countSmsSegments(text: string): SegmentInfo {
  let units = 0;
  let gsm = true;
  for (const ch of text) {
    if (GSM_BASIC.includes(ch)) units += 1;
    else if (GSM_EXTENDED.includes(ch)) units += 2;
    else {
      gsm = false;
      break;
    }
  }
  if (gsm) {
    return { encoding: 'GSM-7', units, segments: units <= 160 ? 1 : Math.ceil(units / 153) };
  }
  // One emoji or curly quote switches the WHOLE message to UCS-2 (70 per
  // segment, 67 when split). Characters outside the BMP take two UTF-16 units.
  const utf16 = text.length;
  return { encoding: 'UCS-2', units: utf16, segments: utf16 <= 70 ? 1 : Math.ceil(utf16 / 67) };
}
